import * as jf from 'joiful';
import { ProductMainGroups } from '../products-matrix/product-main-groups.enum';
import { CaseImageModel } from './case-image.model';
import { CaseLineStatus } from './case-line-status.enum';

export class CaseLineModel {
  @(jf.string().required().max(255))
  public id: string;

  @(jf.string().required().max(255))
  public caseLineNumber: string;

  @(jf.string().required().max(255))
  public productImageUrl: string;

  @(jf.string().required().max(255))
  public productGroupId: string;

  @(jf.string().required().max(255))
  public productGroupName: string;

  @(jf.string().required().max(255))
  public productFabricSize: string;

  @(jf.string().required().max(255))
  public productNumber: string;

  @(jf.string().required())
  public productMainGroup: ProductMainGroups;

  @(jf.string().required().max(255))
  public productName: string;

  @(jf.string().required().max(255))
  public returnDate?: string;

  @(jf.string().required().max(255))
  public productId: string;

  @(jf.string().optional().max(20))
  public status?: CaseLineStatus;

  // for return type
  @(jf.number().required())
  public quantity: number;

  // for warranty type
  @(jf.string().max(255))
  public distanceRun?: string;

  @(jf.string().max(255))
  public defectReason?: string;

  @(jf.string().max(255))
  public comments?: string;

  @(jf.string().max(255))
  public customerName?: string;

  @(jf.string().max(255))
  public purchaseDate?: string;

  @(jf.string().max(255))
  public productCode?: string;

  @(jf.string().max(255))
  public factoryCode?: string;

  @jf.array()
  public images?: CaseImageModel[];

  /**
   * As the name suggests, this field is not accurate.
   * It holds a possible customer's latest confirmed order that the line might have originated from.
   * For more details see https://onrunning.atlassian.net/browse/BACK-366
   */
  @(jf.string().max(50))
  public possibleOriginalOrder?: string;
}
